import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import CustomButton from "../../components/Helpers/CustomButton";
import { useSelector } from "react-redux";
import { useEffect } from "react";

export default function ReportsPage() {
    const { current_staff } = useSelector((state) => state.auth);
    const history = useHistory();
    const [allowClick, setAllowClick] = useState(true);
    const { properties } = useSelector((state) => state.properties);
    const { settings, years } = useSelector((state) => state.settings);
    const [chosenProp, setChosenProp] = useState("");
    const [pageIndex, setPageIndex] = useState(0);
    const [totalToDownload, setTotalToDownload] = useState(0);
    const [downloaded, setDownloaded] = useState(0);
    const [btnLoading, setBtnLoading] = useState(false);
    const [occupancyLoading, setOccupancyLoading] = useState(false);
    const [preOccupancyLoading, setPreOccupancyLoading] = useState(false);
    const [selBookingYear, setSelBookingYear] = useState(settings?.year_id || 0);
    const [reportPropertyId, setReportPropertyId] = useState(0);

    useEffect(async () => {
        if (history.action == "POP") {
            if (allowClick === true) {
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}channels`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}tagsList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}collectionList`,
                });
                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}mentionList/${current_staff.id}`,
                });

                if (settings && settings.brokers === 1) {
                    axios({
                        method: "get",
                        url: `${process.env.REACT_APP_API_URL}brokers`,
                    });
                }

                setAllowClick(false);
            }
        }

        if (pageIndex > 0) {
            mdaSystemTenants();
        } else if (pageIndex == 2) {
            setPageIndex(0);
        }
    }, [pageIndex]);

    async function SummaryReport() {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/export_summary`,
            responseType: "blob",
            data: { year_id: selBookingYear },
        })
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "Summary.xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function SummaryDuplicates() {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/export_duplicates`,
            responseType: "blob",
        })
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "Duplicates.xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function occupancyReport() {
        setOccupancyLoading(true);
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/export_occupancy`,
            responseType: "blob",
            data: { year_id: selBookingYear },
        })
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "Occupancy.xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setOccupancyLoading(false);
            });
    }

    async function preOccupancyReport() {
        setPreOccupancyLoading(true);
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/export_pre_occupancy`,
            responseType: "blob",
            data: { year_id: selBookingYear },
        })
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "Pre-Occupancy.xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setPreOccupancyLoading(false);
            });
    }

    async function mdaMisMatch() {
        await axios({ method: "post", url: `${process.env.REACT_APP_API_URL}reports/mda_mismatch`, responseType: "blob" })
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "MDA Tenants.xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function mdaSystemTenants() {
        setBtnLoading(true);
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/mda_vs_system`,
            responseType: "blob",
            data: { property_id: chosenProp, pageIndex: pageIndex },
        })
            .then((response) => {
                const href = URL.createObjectURL(response.data);

                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "MDA / System Tenants.xlsx");
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((error) => {
                console.log(error);
            });

        let newdownload = downloaded + 1;
        setDownloaded(newdownload);

        if (pageIndex < totalToDownload - 1) {
            let newindex = pageIndex + 1;
            setPageIndex(newindex);
        } else {
            window.location.reload();
        }
    }

    async function mdaUpdate() {
        await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_URL}reports/mda_mismatch_update`,
            responseType: "blob",
        })
            .then((response) => {
                console.log("Done");
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async function downloadCsv() {
        try {
            const response = await axios({
                url: `${process.env.REACT_APP_API_URL}hikcentral/access-report-download?property_id=${reportPropertyId}`,
                method: "POST",
                responseType: "blob",
                headers: {
                    "Content-Type": "text/csv",
                },
            });

            const csvBlob = new Blob([response.data], { type: "text/csv" });
            const url = window.URL.createObjectURL(csvBlob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "report.csv");
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error with generating access report:", error);
            alert("Error generating report");
        }
    }

    const buttonClass =
        "inline-flex items-center px-6 py-2.5 rounded-lg border text-sm font-medium focus:z-10 focus:outline-none border-primary bg-primary text-white hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-out shadow-sm";

    return (
        <div className="h-full w-auto bg-gray-100 my-6 xl:my-0 xl:mx-4 rounded-3xl flex-1 p-8">
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-3xl font-bold text-gray-900">Reports</h1>
                <a
                    href={`${process.env.REACT_APP_API_URL.replace("/api/", "")}/admin/reports`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-6 py-2.5 rounded-lg border text-sm font-medium focus:z-10 focus:outline-none border-primary bg-primary text-white hover:bg-primary_hover focus:ring-primary focus:ring-2 focus:ring-offset-2 transition duration-150 ease-in-out shadow-sm"
                >
                    New Reports
                </a>
            </div>

            {/* General Reports Section */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">General Reports</h2>
                <div className="flex flex-wrap gap-3">
                    <Link className={buttonClass} to="/reports/emaillogs">
                        Email Logs
                    </Link>
                    <Link className={buttonClass} to="/reports/exportall">
                        Export All Students/Tenants
                    </Link>
                    <Link className={buttonClass} to="/reports/exportbeds">
                        Export All Beds
                    </Link>
                    {process.env.REACT_APP_COLOUR === "UC" && (
                        <>
                            <Link className={buttonClass} to="/reports/bedscmm">
                                Beds (Checking In, Moved In, MDA Onboarding)
                            </Link>
                            <Link className={buttonClass} to="/reports/bedscolour">
                                Beds by Colour
                            </Link>
                        </>
                    )}
                    {process.env.REACT_APP_COLOUR === "QP" && (
                        <Link className={buttonClass} to="/reports/snagcodes">
                            Snag Codes Report
                        </Link>
                    )}
                </div>
            </div>

            {/* Activity & Tracking Reports Section */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Activity & Tracking</h2>
                <div className="flex flex-wrap gap-3">
                    {(current_staff.id == "1" || (process.env.REACT_APP_COLOUR === "UC" && (current_staff.id == "291" || current_staff.id == "24024"))) && (
                        <Link className={buttonClass} to="/reports/user-tracking">
                            User Tracking Reports
                        </Link>
                    )}
                    <Link className={buttonClass} to="/reports/chat_audit">
                        Chat Audit
                    </Link>
                    <Link className={buttonClass} to="/reports/user_activity">
                        User Activity
                    </Link>
                    <Link className={buttonClass} to="/reports/chat_movement">
                        Chat Movement
                    </Link>
                    <Link className={buttonClass} to="/reports/bed_allocation">
                        Bed Allocation Summary
                    </Link>
                </div>
            </div>

            {/* Analytics Reports Section */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Analytics & Insights</h2>
                <div className="flex flex-wrap gap-3">
                    {current_staff?.isSuper === 1 && (
                        <Link className={buttonClass} to="/reports/mentions">
                            Mentions Reports
                        </Link>
                    )}
                    {process.env.REACT_APP_COLOUR === "QL" && (
                        <>
                            <Link className={buttonClass} to="/reports/applications">
                                Applications Report (V1)
                            </Link>
                            <Link className={buttonClass} to="/reports/applicationsv2">
                                Applications Report V2 (Funnel)
                            </Link>
                        </>
                    )}
                    <Link className={buttonClass} to="/reports/renewals">
                        Renewals Report
                    </Link>
                    <Link className={buttonClass} to="/reports/viewings">
                        Appointments Report
                    </Link>
                    <Link className={buttonClass} to="/reports/keywords">
                        Keywords Report
                    </Link>
                    <Link className={buttonClass} to="/reports/move_outs">
                        Move Outs Report
                    </Link>
                    <Link className={buttonClass} to="/reports/parking_bays">
                        Parking Bay Report
                    </Link>
                </div>
            </div>

            {/* UC Specific Reports */}
            {process.env.REACT_APP_COLOUR === "UC" && (
                <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">UC Specific Reports</h2>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Select Year</label>
                        <select
                            className="block w-full max-w-xs px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                            value={selBookingYear}
                            onChange={(e) => setSelBookingYear(parseInt(e.target.value))}
                        >
                            {years &&
                                years.length > 0 &&
                                years.map((year) => (
                                    <option key={year.id} value={year.id}>
                                        {year.year}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <div className="flex flex-wrap gap-3">
                        <CustomButton className={buttonClass} text="Occupancy Report" onClick={() => occupancyReport()} loading={occupancyLoading} />
                        <CustomButton className={buttonClass} text="Pre-Occupancy Report" onClick={() => preOccupancyReport()} loading={preOccupancyLoading} />
                        <Link className={buttonClass} to="/reports/raa">
                            RAA Report
                        </Link>
                    </div>
                </div>
            )}

            {/* MDA & System Tenants Section */}
            {process.env.REACT_APP_COLOUR === "UC" && (
                <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">MDA & System Tenants</h2>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">Select Property</label>
                        <select
                            name="action_type"
                            onChange={(e) => {
                                setChosenProp(e.target.value);
                                if (e.target.value == 38 || e.target.value == 32 || e.target.value == 35) {
                                    setTotalToDownload(3);
                                } else if (e.target.value == 37) {
                                    setTotalToDownload(2);
                                } else if (e.target.value == 33) {
                                    setTotalToDownload(4);
                                } else if (e.target.value == 36) {
                                    setTotalToDownload(5);
                                } else if (e.target.value == 34) {
                                    setTotalToDownload(9);
                                }
                            }}
                            className="block w-full max-w-md border border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                        >
                            <option value="">Choose One</option>
                            {properties &&
                                properties.length > 0 &&
                                properties.map((p) => (
                                    <option key={p.value} value={p.value}>
                                        {p.label}
                                    </option>
                                ))}
                        </select>
                    </div>
                    <CustomButton className={buttonClass} text="MDA & System Tenants" onClick={() => mdaSystemTenants()} loading={btnLoading} />
                    {chosenProp !== "" && (
                        <p className="mt-3 text-sm text-gray-600">
                            {downloaded} of {totalToDownload} downloaded
                        </p>
                    )}
                </div>
            )}

            {/* Financial Reports Section */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Financial Reports</h2>
                <div className="flex flex-wrap gap-3">
                    <Link className={buttonClass} to="/reports/additional_invoices">
                        Additional Invoices
                    </Link>
                    <Link className={buttonClass} to="/reports/bank_details_changes">
                        Bank Details Changes
                    </Link>
                    <a href={`${process.env.REACT_APP_API_URL.replace("/api/", "")}/admin/reports/pricing-anomalies`} target="_blank" rel="noopener noreferrer" className={buttonClass}>
                        Pricing Anomalies
                        <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                        </svg>
                    </a>
                </div>
            </div>

            {/* Access Control Reports Section */}
            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Access Control Reports</h2>
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Select Property for Access Report</label>
                    <select
                        name="action_type"
                        className="block w-full max-w-md border border-gray-300 rounded-lg shadow-sm py-2 px-3 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                        onChange={(e) => {
                            setReportPropertyId(e.target.value);
                        }}
                    >
                        <option value="">Choose One</option>
                        {properties &&
                            properties.length > 0 &&
                            properties.map((p) => (
                                <option key={p.value} value={p.value}>
                                    {p.label}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="flex flex-wrap gap-3">
                    <CustomButton className={buttonClass} text="Download Hikcentral Access Report" onClick={() => downloadCsv()} />
                    <Link className={buttonClass} to="/reports/biometrics_activity">
                        Biometrics Activity Monitor
                    </Link>
                    <Link className={buttonClass} to="/reports/biometrics_occupancy">
                        Biometrics Occupancy
                    </Link>
                    <Link className={buttonClass} to="/reports/weekend_passes">
                        Pass-Outs
                    </Link>
                </div>
            </div>

            {/* WiFi Management Reports Section */}
            <div className="bg-white rounded-xl shadow-sm p-6">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">WiFi Management Reports</h2>
                <div className="flex flex-wrap gap-3">
                    <Link className={buttonClass} to="/reports/wifi_disconnections">
                        WiFi Disconnections
                    </Link>
                </div>
            </div>
        </div>
    );
}
